import { render, staticRenderFns } from "./pupilcard.vue?vue&type=template&id=65593cca&"
import script from "./pupilcard.vue?vue&type=script&lang=js&"
export * from "./pupilcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports